// extracted by mini-css-extract-plugin
export default {"root":"ReferralInfoItem__root--2iFdM","info":"ReferralInfoItem__info--2pDXB","title":"ReferralInfoItem__title--vnvdv","description":"ReferralInfoItem__description--2N_JL"};